import React from 'react';
import { motion } from 'framer-motion';

/**
 * Animated confirmation state — replaces flat "Submitted ✅" text blocks. `steps` is an optional
 * mini timeline, e.g. ['Submitted', 'We review', 'You get a price'], with the first step always
 * marked complete (this moment).
 */
export default function SuccessState({ title, message, steps, children }) {
  return (
    <div style={{ textAlign: 'center', padding: '24px 0' }}>
      <motion.svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        style={{ margin: '0 auto 16px' }}
        initial="hidden"
        animate="visible"
      >
        <motion.circle
          cx="32"
          cy="32"
          r="30"
          stroke="var(--primary-color)"
          strokeWidth="3"
          variants={{ hidden: { pathLength: 0 }, visible: { pathLength: 1 } }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        />
        <motion.path
          d="M20 33 L28 41 L44 24"
          stroke="var(--primary-color)"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          variants={{ hidden: { pathLength: 0 }, visible: { pathLength: 1 } }}
          transition={{ duration: 0.4, delay: 0.35, ease: 'easeOut' }}
        />
      </motion.svg>

      <div className="callout">
        <h3>{title}</h3>
        {message && <p>{message}</p>}
      </div>

      {steps && steps.length > 0 && (
        <div className="timeline" style={{ maxWidth: 420, margin: '24px auto 0' }}>
          {steps.map((label, i) => (
            <div key={label} className={`timeline-step${i === 0 ? ' is-complete' : ''}`}>
              <div className="timeline-node">{i === 0 ? '✓' : i + 1}</div>
              <div className="timeline-label">{label}</div>
            </div>
          ))}
        </div>
      )}

      {children && <div style={{ marginTop: '20px' }}>{children}</div>}
    </div>
  );
}
